import { useForm } from "react-hook-form";
import { EsuraApiConnectionPropertiesType } from "../../types/SettingsType";
import { useEsuraApiConnectionProperties } from "../../hooks/useEsuraApiConnectionProperties";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";
import { Flex, Card, Button, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  createEsuraApiConnectionProperties,
  updateEsuraApiConnectionProperties,
  deleteEsuraApiConnectionProperties,
} from "../../services/esuraApiConnectionProperties";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { yupResolver } from "@hookform/resolvers/yup";
import EsuraApiConnectionPropertiesFormValidation from "../Courses/EsuraApiConnectionPropertiesFormValidation";

export const EsuraApiConnectionProperties = () => {
  const { data, isLoading, refetch } = useEsuraApiConnectionProperties();
  const [showPassword, setShowPassword] = useState(false);
  const [updateProperties, setUpdateProperties] =
    useState<EsuraApiConnectionPropertiesType | null>(null);
  const [saveProperties, setSaveProperties] =
    useState<EsuraApiConnectionPropertiesType | null>(null);
  const [removeProperties, setRemoveProperties] =
    useState<EsuraApiConnectionPropertiesType | null>(null);


  const confirmSave = async () => {
    if (saveProperties) {
      await createEsuraApiConnectionProperties(saveProperties);
      toast.success("Configuração salva com sucesso!");
      setSaveProperties(null);
      reset();
    }
  };

  const confirmUpdate = async () => {
    if (updateProperties) {
      await updateEsuraApiConnectionProperties(updateProperties);
      toast.success("Configuração atualizada!");
      setUpdateProperties(null);
      reset();
    }
  };
  const confirmRemove = async () => {
    if (removeProperties?.id) {
      await deleteEsuraApiConnectionProperties(removeProperties.id);
      toast.success("Configuração removida!");
      setRemoveProperties(null);
      reset();
    }
  };
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<EsuraApiConnectionPropertiesType>({
    resolver: yupResolver(EsuraApiConnectionPropertiesFormValidation),
    defaultValues: data ?? {
      url: "",
      username: "",
      password: "",
      baseUrl: "",
    },
  });

  useEffect(() => {
    if (data?.id) {
      reset(data);
    }
  }, [data, reset]);

  return (
    <>
      {isLoading ? (
        <>
          {" "}
          <Spinner />
        </>
      ) : (
        <Flex direction="column" gap="3" mt="4">
          <Card>
            <form
              onSubmit={handleSubmit((values) => {
                if (data?.id) {
                  setUpdateProperties(values);
                } else {
                  setSaveProperties(values);
                }
              })}
              noValidate
            >
              <Flex direction="column" gap="3">
                <TextFieldComponent
                  name="baseUrl"
                  label="Url Pública do esura local"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "Url Pública do esura local" }}
                />
                <TextFieldComponent
                  name="url"
                  label="URL do Esura Central"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "URL do Esura Central" }}
                />

                <TextFieldComponent
                  name="username"
                  label="Username"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "Digite o username" }}
                />

                <div style={{ position: "relative", width: "100%" }}>
                  <TextFieldComponent
                    name="password"
                    label="Password"
                    control={control}
                    errors={errors}
                    fieldProps={{
                      type: showPassword ? "text" : "password",
                      placeholder: "Digite a senha",
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "38px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
                  </button>
                </div>

                <Flex direction="row" gap="3" style={{ alignSelf: "end" }}>
                  <Button type="submit" color={data?.id ? "blue" : "green"}>
                    {data?.id ? "Atualizar" : "Salvar"}
                  </Button>

                  {data?.id && (
                    <Button
                      type="button"
                      color="red"
                      onClick={() => setRemoveProperties(data)}
                    >
                      Remover
                    </Button>
                  )}
                </Flex>
              </Flex>
            </form>
          </Card>
        </Flex>
      )}

      <ConfirmAlertDialog
        open={!!saveProperties}
        onOpenChange={(open) => !open && setSaveProperties(null)}
        title="Salvar configuração"
        item={saveProperties}
        onConfirm={confirmSave}
        onCancel={() => setSaveProperties(null)}
      />

      <ConfirmAlertDialog
        open={!!updateProperties}
        onOpenChange={(open) => !open && setUpdateProperties(null)}
        title="Atualizar configuração"
        item={updateProperties}
        onConfirm={confirmUpdate}
        onCancel={() => setUpdateProperties(null)}
      />

      <ConfirmAlertDialog
        open={!!removeProperties}
        onOpenChange={(open) => !open && setRemoveProperties(null)}
        title="Remover configuração"
        item={removeProperties}
        onConfirm={confirmRemove}
        onCancel={() => setRemoveProperties(null)}
      />
    </>
  );
};
